<script>
import { RouterView } from "vue-router";
import customIDClassesGenerator from "./assets/js/impactdriver_front/customIDClassesGenerator";
import { fetchImpactDriverStatuses } from "./assets/js/impactdriver_front/requests";
import { useMainStore } from "./stores/main";
import FloatingAIButton from "./components/GlobalAI/FloatingAIButton.vue";
import TheNavbar from "./components/TheNavbar.vue";

export default {
  components: { FloatingAIButton, TheNavbar },
  data() {
    return { impactdriverStatuses: [] };
  },
  computed: {
    isEmbedded() {
      const name = this.$route?.name || "";
      return name.startsWith("embedded_") || this.$route?.hash === "#embedded";
    },
    showAppChrome() {
      const name = this.$route?.name;
      if (!name || name === "onboarding") return false;
      return !this.isEmbedded;
    },
    isExtensionHome() {
      return this.$route?.name === "embedded_home";
    },
    navbarUserData() {
      return useMainStore().userData;
    },
  },
  async mounted() {
    useMainStore()
      .ensureUserData()
      .catch(() => {});
    useMainStore().ensureFeatureFlags();
    this.impactdriverStatuses = await fetchImpactDriverStatuses();
    if (this.impactdriverStatuses.constructor !== Array) return; // will be the case when user is not logged in, for example first step of onboarding.

    const idColorClassGenerator = new customIDClassesGenerator();
    idColorClassGenerator.createClassesForIDColors(this.impactdriverStatuses);
  },
};
</script>

<template>
  <TheNavbar
    v-if="showAppChrome && navbarUserData"
    :userData="navbarUserData" />
  <RouterView />
  <FloatingAIButton
    v-if="showAppChrome || isExtensionHome"
    :showButton="isExtensionHome" />
</template>
